module.exports = __webpack_public_path__ + "img/exit_to_app.a3482392.svg";